// ExchangeCreate.jsx
import React from "react";
import {Typography,} from "antd";
import StageBar from "./StageBar";

const {Title, Text} = Typography;

export default function Shell({stage, title, subtitle, children, minBodyHeight = 720}) {
  return (
    <div className="w-full">
      <div className="max-w-[980px] mx-auto">
        <div
          className="bg-white rounded-[18px] border border-black/5 shadow-[0_14px_40px_rgba(16,24,40,0.12)] overflow-hidden">
          {/* статус-бар внутри контейнера */}
          <StageBar stage={stage}/>

          <div
            className="px-8 py-8 max-[520px]:px-4 max-[520px]:py-5 content-center"
            style={{minHeight: minBodyHeight}}
          >
            <div className="text-center">
              <Title className="!m-0 !text-[34px] !font-extrabold !leading-[1.15] !text-[#0B1B3A]">
                {title}
              </Title>
              {subtitle ? (
                <Text className="block mt-1 text-[15px] text-[#6B7280]">{subtitle}</Text>
              ) : null}
            </div>

            <div className="mt-7">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
